import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createExpenseCategoryService, type CreateExpenseCategoryPayload } from '@/services/expenseCategories'
import { expenseCategoriesQueryKey } from './useExpenseCategories'

export const useCreateExpenseCategory = (agendaId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: CreateExpenseCategoryPayload) => createExpenseCategoryService(agendaId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: expenseCategoriesQueryKey(agendaId) })
    },
  })
}
